export const SIMILAR_RESULTS_PER_PAGE = 12;
